export enum Path {
  Home = '/',
  AboutMe = '/about',
  Resume = '/resume',
  Projects = '/projects',
  Contact = '/contact',
  Unknown = '*',
}
